import {
  AudioWaveform,
  Command,
  CreditCard,
  FileStack,
  FileText,
  FolderOpen,
  GalleryVerticalEnd,
  LayoutDashboard,
  MapPin,
  Factory,
  Monitor,
  Package,
  PieChart,
  Settings,
  Share2,
  ShoppingBag,
  ShoppingCart,
  Star,
  Store,
  Truck,
  UserCircle,
  UserCog,
  Users,
} from "lucide-react";
import type { SidebarData } from "../types";

export const sidebarData: SidebarData = {
  teams: [
    { name: "Shadcn Admin", logo: Command, plan: "Vite + ShadcnUI" },
    { name: "Acme Inc", logo: GalleryVerticalEnd, plan: "Enterprise" },
    { name: "Acme Corp.", logo: AudioWaveform, plan: "Startup" },
  ],
  navGroups: [
    {
      title: "ທົ່ວໄປ",
      items: [
        {
          title: "ແຜງຄວບຄຸມ",
          url: "/app/dashboard",
          icon: LayoutDashboard,
        },
        {
          title: "ລາຍງານກຣາຟຊຳລະ",
          url: "/app/reports",
          icon: PieChart,
          requiredPermissions: ["payments:read"],
        },
      ],
    },
    {
      title: "ແຄັດຕາລອກ",
      items: [
        {
          title: "ຄຳເຫັນສິນຄ້າ",
          url: "/app/reviews",
          icon: Star,
          requiredPermissions: ["reviews:read"],
        },
        {
          title: "ສິນຄ້າ",
          url: "/app/catalog/products",
          icon: ShoppingBag,
          requiredPermissions: ["catalog:read"],
        },
        {
          title: "ແບບຮັບຜະລິດ",
          url: "/app/catalog/production",
          icon: Factory,
          requiredPermissions: ["catalog:read"],
        },
        {
          title: "ແບບສິນຄ້າອອນໄລນ໌",
          url: "/app/catalog/online-showcase",
          icon: Monitor,
          requiredPermissions: ["catalog:read"],
        },
        {
          title: "ຫມວດມູ່",
          url: "/app/catalog/categories",
          icon: FolderOpen,
          requiredPermissions: ["catalog:read"],
        },
        {
          title: "ຕົວເລືອກ",
          url: "/app/catalog/options",
          icon: FolderOpen,
          requiredPermissions: ["options:read"],
        },
        {
          title: "ຄໍເລັກຊັນ",
          url: "/app/catalog/collections",
          icon: FolderOpen,
          requiredPermissions: ["catalog:read"],
        },
      ],
    },
    {
      title: "ລູກຄ້າ",
      items: [
        {
          title: "ລູກຄ້າ",
          url: "/app/customers",
          icon: UserCircle,
          requiredPermissions: ["customers:read"],
        },
        {
          title: "ລະດັບສະມາຊິກ",
          url: "/app/customers/tiers",
          icon: UserCircle,
          requiredPermissions: ["customers:read"],
        },
        {
          title: "ກຸ່ມລູກຄ້າ",
          url: "/app/customers/groups",
          icon: Users,
          requiredPermissions: ["customers:read"],
        },
      ],
    },
    {
      title: "ຄຳສັ່ງຊື້",
      items: [
        {
          title: "POS",
          url: "/app/pos",
          icon: Store,
          requiredPermissions: ["pos:checkout", "inventory:read"],
        },
        {
          title: "ຄຳສັ່ງຊື້",
          url: "/app/orders",
          icon: ShoppingCart,
          requiredPermissions: ["orders:read"],
        },
        {
          title: "ການຊຳລະ",
          url: "/app/payments",
          icon: CreditCard,
          requiredPermissions: ["payments:read"],
        },
      ],
    },
    {
      title: "ສາງສິນຄ້າ",
      items: [
        {
          title: "ສະຕ໋ອກ",
          url: "/app/inventory/stock",
          icon: Package,
          requiredPermissions: ["inventory:read"],
        },
        {
          title: "ບັນທຶກການເຄື່ອນໄຫວ",
          url: "/app/inventory/movements",
          icon: FileText,
          requiredPermissions: ["inventory:read"],
        },
      ],
    },
    {
      title: "ພູມິສາດ",
      items: [
        {
          title: "ແຂວງ",
          url: "/app/geo/provinces",
          icon: MapPin,
          requiredPermissions: ["geo:read"],
        },
        {
          title: "ເມືອງ",
          url: "/app/geo/districts",
          icon: MapPin,
          requiredPermissions: ["geo:read"],
        },
      ],
    },
    {
      title: "ຄ່າສົ່ງ",
      items: [
        {
          title: "ຜູ້ຂົນສົ່ງ",
          url: "/app/shipping/carriers",
          icon: Truck,
          requiredPermissions: ["shipping:read"],
        },
        {
          title: "ໂຊນ",
          url: "/app/shipping/zones",
          icon: Package,
          requiredPermissions: ["shipping:read"],
        },
        {
          title: "ອັດຕາຄ່າສົ່ງ",
          url: "/app/shipping/rates",
          icon: Package,
          requiredPermissions: ["shipping:read"],
        },
        {
          title: "ຕັ້ງຄ່າຄ່າສົ່ງ",
          url: "/app/shipping/settings",
          icon: Package,
          requiredPermissions: ["shipping:read"],
        },
      ],
    },
    {
      title: "ເນື້ອຫາ",
      items: [
        {
          title: "ສ່ວນຫນ້າເວັບ",
          url: "/app/cms/sections",
          icon: FileStack,
          requiredPermissions: ["cms:read"],
        },
      ],
    },
    {
      title: "ຕັ້ງຄ່າ",
      items: [
        {
          title: "ທົ່ວໄປ",
          url: "/app/settings",
          icon: Settings,
          requiredPermissions: ["settings:read"],
        },
        {
          title: "ແຫຼ່ງຂາຍ Social Media",
          url: "/app/settings/social-sales-sources",
          icon: Share2,
          requiredPermissions: ["social_sources:read"],
        },
      ],
    },
    {
      title: "ການຄວບຄຸມການເຂົ້າເຖິງ",
      items: [
        {
          title: "ບົດບາດ",
          url: "/app/roles",
          icon: UserCog,
          requiredPermissions: ["users:read"],
        },
        {
          title: "ຜູ້ໃຊ້",
          url: "/app/users",
          icon: Users,
          requiredPermissions: ["users:read"],
        },
      ],
    },
  ],
};
